import Button from 'components/Button'
import ButtonPrimary from 'components/ButtonPrimary'
import Form from 'components/Form'
import { ArrowLeftIcon } from 'components/Icon/icons/arrow-left'
import { LoadingIcon } from 'components/Icon/icons/loading'
import Input from 'components/Input'
import Text from 'components/Text'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'

const messages = defineMessages({
  emailOrName: {
    id: 'SigninSignupFlowForgotPassword.emailOrName',
    defaultMessage: 'Email or name'
  },
  weWillSendYouALink: {
    id: 'SigninSignupFlowForgotPassword.weWillSendYouALink',
    defaultMessage: 'We will send you a link to reset your password'
  },
  send: {
    id: 'SigninSignupFlowForgotPassword.Send',
    defaultMessage: 'Send'
  },
  back: {
    id: 'SigninSignupFlowForgotPassword.back',
    defaultMessage: 'Back'
  },
  enterEmailOrName: {
    id: 'SigninSignupFlowForgotPassword.enterEmailOrName',
    defaultMessage: 'Enter your email or name'
  }
})

export default function SigninSignupFlowForgotPassword (props) {
  const intl = useIntl()
  const {
    handleClickBack,
    loading,
    emailOrName,
    handleChangeEmailOrName,
    setIsInvalidEmailOrNameField,
    isEmailOrNameValid,
    isInvalidEmailOrNameField,
    handleSubmitForgotPassword
  } = props
  return (
    <>
      <Button onClick={handleClickBack}>
        <View
          row
          ac
        >
          <ArrowLeftIcon style={{
            width: '0.95em',
            height: '0.95em'
          }}
          />
          <Text
            ml='4px'
            fs='0.75em'
          >{formatMessageIntlUtil(intl, messages.back)}
          </Text>
        </View>
      </Button>
      <View
        row
        style={{ justifyContent: 'space-between' }}
      >
        <Text
          fw='700'
          fs='1.125em'
          c='#151D21'
          style={{
            textTransform: 'uppercase',
            lineHeight: '22px',
            transform: 'scaleX(0.8) scaleY(0.9)',
            transformOrigin: '0 0',
            textAlign: 'left'
          }}
        >
          {formatMessageIntlUtil(intl, messages.weWillSendYouALink)}
        </Text>
        {loading && (
          <LoadingIcon
            stroke='black'
            style={{
              width: '30px',
              height: '30px'
            }}
          />
        )}
      </View>
      <Form>
        <Input
          isFocused
          type='text'
          value={emailOrName}
          placeholder={formatMessageIntlUtil(intl, messages.emailOrName)}
          onChange={handleChangeEmailOrName}
          onBlur={() => setIsInvalidEmailOrNameField(!isEmailOrNameValid && emailOrName.length > 0)}
          style={{
            background: '#F6F6F6',
            color: '#151D21',
            borderRadius: '8px',
            border: isInvalidEmailOrNameField ? '1px solid red' : 'none',
            padding: '10px 13px',
            marginTop: '16px'
          }}
        />
        <View>
          <ButtonPrimary
            isDisabled={!isEmailOrNameValid || loading}
            isFullWidth
            onClick={handleSubmitForgotPassword}
            style={{ marginTop: '34px' }}
          >
            <Text
              c='#ffffff'
              fs='0.9375em'
            >
              {formatMessageIntlUtil(intl, messages.send)}
            </Text>
          </ButtonPrimary>
        </View>
      </Form>
    </>
  )
}
